import { logoutAndClearCaches } from "../../../utils/auth";
import { stopPresenting } from "../../../utils/presentation";

import { ClassSessionType } from "components/server-types";
import { AppDispatch } from "store/index";

export const onLogout = (presentingSessions: ClassSessionType[], dispatch: AppDispatch) => () => {
  // Stop all sessions that the user is presenting in
  for (const session of presentingSessions) {
    stopPresenting(session.id);
  }

  logoutAndClearCaches(dispatch);
};
